'use client'

import { useLocale } from 'next-intl'
import { resolveContentLocale } from '../_utils/dynamic-language'
import { useDynamicLanguage } from './useShipper'

export const useCustomLocale = () => {
  const locale = useLocale()
  const { useDynamicLanguage: dynamic } = useDynamicLanguage()
  return resolveContentLocale(locale, dynamic)
}
